import { ButtonVariant } from "../buttons";
import { ButtonSize } from "../theme";

import { BannerVariant } from "./types";
import BannerAction from "./BannerAction";
import type { BannerActionProps } from "./types";

export interface PrimaryActionProps {
  variant: BannerVariant;
  value?: BannerActionProps;
}

const PrimaryAction: React.FC<PrimaryActionProps> = (props) => {
  if (props.value == null) {
    return null;
  }

  let btnVariant = ButtonVariant.PrimaryOnLight;
  switch (props.variant) {
    case BannerVariant.Dark:
      btnVariant = ButtonVariant.PrimaryOnDark;
      break;
    case BannerVariant.FullBleed:
      btnVariant = ButtonVariant.Inline;
      break;
  }

  return (
    <BannerAction {...props.value} variant={btnVariant} size={ButtonSize.Md} />
  );
};

export default PrimaryAction;
